import TagManager from 'react-gtm-module';
import { GTM_ID, GTM_ID_GENERAL } from '../config/index';
import { getCurrentUser } from './CommonUtil';
export var USER_ID_EVENT = 'user_id_ready';
var lastPushedUserId = null;
var getCurrentUserId = function () {
    var currentUser = getCurrentUser();
    return currentUser && currentUser.id ? currentUser.id : null;
};
export var initAnalytics = function () {
    var gtmIds = [GTM_ID, GTM_ID_GENERAL].filter(function (gtmId) { return !!gtmId; });
    if (!gtmIds.length) {
        return;
    }
    var userId = getCurrentUserId();
    gtmIds.forEach(function (gtmId) { return TagManager.initialize({ gtmId: gtmId, dataLayer: { user_id: userId } }); });
};
export var syncUserIdToDataLayer = function () {
    var userId = getCurrentUserId();
    if (userId === lastPushedUserId) {
        return;
    }
    lastPushedUserId = userId;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: USER_ID_EVENT, user_id: userId });
};
